import './App.scss';
import Onboarding from './components/Onboarding/Onboarding';
import Header from './components/Header/Header';
function App() {
  return (
    <div className="App">
      <Header />
      <Onboarding />
    </div>
  );
}

export default App;
